import axios from "axios";
import store from "../index";
import history from "../Utils/History";
import { sessionExpired } from "../Redux/Actions/keyCloakAction";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

axios.defaults.withCredentials = true;

axios.defaults.headers.common = {
  ...axios.defaults.headers.common,
  "Content-Type": "application/json",
};

axios.defaults.preflightContinue = true;

const http = axios.create({
  //baseURL: "http://localhost:8086/webappdemo-api",
  // baseURL: "http://MCMRWP-OSD03:8087/webapp-api/",
  //baseURL: "https://dev1.medadvantage360.com", //vanilla
  // baseURL: "https://dev2.enroll.medadvantage360.net", //sharp, BCBNS
  //baseURL:"https://dev.enroll.medadvantage360.net", //Varda
   baseURL: "/", //while commiting this file
  //baseURL: "/webappdemo-api/",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers": "*",
  },
});
http.interceptors.request.use(function (config) {
  try {
    const state = store.getState();
    let { token, temporaryKeyCloaktoken, agentId } = state.login;
    let planYear = state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year;
    let { userId, customerId, agencyIDSelected } = state.login;
    if (config.url.includes("/token")) {
      config.headers["token"] = temporaryKeyCloaktoken;
    } else {
      // if(!config.url.includes("/logout")){
      config.headers["Authorization"] = "Bearer " + token;
      // }
    }
    // let urls = [
    //   // "/beneficiary-api/beneficiary/applicationStatus",
    //   "/beneficiary-api/beneficiary/submitted/applicationStatus",
    //   "/beneficiary-api/beneficiary/submitted/applicationStatusByDates",
    //   "/beneficiary-api/beneficiary/searchExisting",
    // ];
    // let flag = urls.some((url) => url===config.url);
    // if(flag===true){
    config.headers["X-USER-ID"] = userId ?? "";
    config.headers["X-CUSTOMER-ID"] = customerId ?? "";
    config.headers["X-AGENCY-ID"] = agencyIDSelected ?? "";
    // }
    if (
      config.url === "/beneficiary-api/beneficiary/applicationStatus" &&
      config.headers["X-USER-ID"] === ""
    ) {
      config.headers["X-USER-ID"] = userId ?? "";
    }
    if (config.url === "/beneficiary-api/ltcList") {
      config.headers["planYear"] = planYear ?? "";
    }
    if (config.url.includes("/e-enroll-agent-api/appointment/details")) {
      config.headers["X-AGENT-ID"] = agentId ?? "";
    }
  } catch (err) {
    console.log(err);
  }
  return config;
});
http.interceptors.response.use(
  function (response) {
    // console.log("responsehttp-",response,response.headers["x-auth-token"])
    if (response.headers["x-auth-token"]) {
      window.sessionStorage.setItem("token", response.headers["x-auth-token"]);
      function tokenDisp() {
        return {
          type: "TOKEN_TO_REDUX",
          payload: response.headers["x-auth-token"],
        };
      }
      store.dispatch(tokenDisp());
    }
    const statevalues = store.getState();
    //when we open any page in other tab it wil redirect to login and also for copy link it should work properly
    // console.log("clstokn",window.sessionStorage.getItem("token"),"deep",statevalues.login.deeplinkflag,"windowdeep",window.location.search.includes("deepLink=true"),"reset",statevalues.login.isResetPwd)
    if (
      (window.sessionStorage.getItem("token") === "" ||
        window.sessionStorage.getItem("token") === null) &&
      //statevalues.login.deeplinkflag === false &&
      (window.location.search.includes("deepLink=true")
        ? !window.location.search.includes("deepLink=true")
        : statevalues.login.deeplinkflag === false) &&
      statevalues.login.isResetPwd === false &&
      !window.location.href.includes("/e-Enroll/dashboard")
    ) {
      history.push("/e-Enroll/Login");
    }
    return response;
  },
  function (error) {
    if (
      window.sessionStorage.getItem("token") != "" &&
      window.sessionStorage.getItem("token") != null
    ) {
      if (
        error.response.status === 401 ||
        (error.response.status === 500 &&
          error.response.data.message === "Authorization has expired")
      ) {
        // alert("Session Expired");
        window.sessionStorage.setItem("isExpired", true);
        store.dispatch(sessionExpired(true));
        // history.push("/e-Enroll/Login");
      }
    }
    return Promise.reject(error);
  }
);
export default http;

export const isValidHttpUrl = (string) => {
  try {
    const newUrl = new URL(string);
    if (newUrl.protocol === "http:" || newUrl.protocol === "https:") {
      return newUrl;
    }
  } catch (err) {
    return false;
  }
};
